/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, May 2023
 * @flow
 */

import React from 'react';
import Whiteboard from '../../../../Playground/components/Body/Whiteboard';
import { Box } from '@material-ui/core';

const RightSection = ({
    shapes,
    onSelectShape,
}) => {

    return (
        <Box height={'100%'}>
            <Whiteboard
                draggable={false}
                shapes={shapes}
                selectShape={onSelectShape}
                backgroundColor={'#2a2a2a'}
                stageContainerBackgroundColor={'#2a2a2a'}
                tableInfoColumn='stationNumber'
                keyName1='openTime'
                keyName2_primary='closedTime'
                keyName2_secondary='totalAmount'
                keyName3='guestCount'
            />
        </Box>
    );
};

export default RightSection;
